module.exports = __webpack_public_path__ + "static/img/frame-02.5dd8370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/frame-02.png
// module id = 8t8C
// module chunks = 1